import { render, staticRenderFns } from "./tradeInProcess.vue?vue&type=template&id=0598cb03&scoped=true"
import script from "./tradeInProcess.vue?vue&type=script&lang=js"
export * from "./tradeInProcess.vue?vue&type=script&lang=js"
import style0 from "./tradeInProcess.vue?vue&type=style&index=0&id=0598cb03&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0598cb03",
  null
  
)

export default component.exports